import React, { useEffect, useState } from 'react';

import IoTDevListGrid from './IoTDevListGrid';
import { IoTDevListStyle } from './IoTDevListStyle';

/**
 * IoTBox機器一覧
 * @returns
 */
const IoTDevListPage: React.FC = () => {
  const pageStyle = IoTDevListStyle();

  return <IoTDevListGrid tableContainerStyle={pageStyle.tableContainer} />;
};

export default IoTDevListPage;
